import React from 'react';
import { Typography } from '../common/Typography';
import { Content } from '../services/UploadManagementServiceTypes';

const formatDate = (dateString: string) =>
  Intl.DateTimeFormat('en-GB', {
    hour12: true,
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(dateString));

export const ContentDate: React.FC<{ content: Content }> = ({ content }) => (
  <Typography>{formatDate(content.modifiedAt || content.createdAt)}</Typography>
);
